import { FloatingContextProvider, FloatingElementOptions } from 'library/floating';
import { FC, ReactNode } from 'react';

interface DropdownProps
    extends Pick<FloatingElementOptions, 'open' | 'setOpen' | 'placement' | 'offset' | 'showArrow' | 'closeOnScroll'> {
    children: ReactNode;
}
const Dropdown: FC<DropdownProps> = (props) => {
    const { placement = 'bottom-end', offset = 8, closeOnScroll = true, children, ...rest } = props;

    return <FloatingContextProvider {...rest}>{children}</FloatingContextProvider>;
};

export default Dropdown;
